import { createSelector } from 'reselect';
import { selectAttachFlowing, selectBenchFlowing, selectEvolveCardPosition, selectEvolveFlowing } from '../Pokemon/selectors';
import { selectOptions } from '../ActiveGame/selectors';
import { evolveTargets } from '../ActiveGame/options';
import { selectChoosingBenchPosition } from '../RetreatButton/selectors';
import { selectPicksChoosing, selectPicksSource, selectPicksStep, selectSubmittingPicks } from '../Picks/selectors';
import { picksPokemon } from '../Picks/constants';

/** What the player is picking on the board right now. */
export const ATTACH_TARGET = 'attach';
export const BENCH_SPOT = 'bench';
export const SWITCH_IN = 'switch';
export const EVOLVE_TARGET = 'evolve';
/** A Trainer or Pokémon Power step picks a Pokémon, yours or the opponent's. */
export const PICK_TARGET = 'pick';

export const selectBoardChoice = createSelector(
  [
    selectAttachFlowing, selectBenchFlowing, selectChoosingBenchPosition, selectEvolveFlowing, selectPicksSource,
    selectPicksChoosing, selectPicksStep, selectSubmittingPicks,
  ],
  (attachFlowing, benchFlowing, choosingBenchPosition, evolveFlowing, picksSource, picksChoosing, picksStep, submittingPicks) => {
    if (attachFlowing) {
      return ATTACH_TARGET;
    }
    if (evolveFlowing) {
      return EVOLVE_TARGET;
    }
    // Energy cards, pile cards and types are picked in the menu, off the board; the board waits while the Trainer
    // is played or the Power used.
    if (picksSource !== null && picksChoosing === null && (picksPokemon(picksStep) || submittingPicks)) {
      return PICK_TARGET;
    }
    if (benchFlowing) {
      return BENCH_SPOT;
    }
    if (choosingBenchPosition) {
      return SWITCH_IN;
    }
    return null;
  }
);

/** While evolving: where the chosen card can go, from the server ('active' and bench positions). */
export const selectEvolveTargets = createSelector(
  [selectOptions, selectEvolveCardPosition],
  (options, handPosition) => (handPosition === null ? [] : evolveTargets(options, handPosition)),
);

